import React from "react";
import { Menu, Card, Divider } from "antd";
import Helmet from "react-helmet";
import PetitionsFiledSection from "./petitions-filed-container";
import PetitionsBySectorSection from "./petitions-by-sector-container";
import HighTechPatentOwnersSection from "./high-tech-patent-owners-container";
import MostActivePetitioners from "./most-active-petitioners-container";
import MostActivePatentOwners from "./most-active-patent-owners-container";
import InstitutionRateContainer from "./institution-rate-container";
import { range as _range, toInteger as _toInteger } from "lodash";

const styles = {
  body: {
    width: "100%",
    padding: 30
  },
  gutter: {
    marginTop: 16
  }
};

const AnnualReport = props => {
  const latestYear = new Date().getUTCFullYear() - 1;
  const year = _toInteger(props.location.query.year) || latestYear;
  const helmet = {
    title: `${year} PTAB Annual Report`,
    meta: [
      {
        name: "keywords",
        content: `PTAB cases with NPE patent owner,PTAB Institution Rate,PTAB Cases by industry,top PTAB petitioners,top PTAB patent owners`
      },
      {
        name: "description",
        content: `Unified’s PTAB Annual Report provides a breakdown of PTAB cases filed every year. The interactive search allows users to identify numerical patterns in information like institution rate, top companies, and sector.`
      }
    ]
  };
  const yearSelector = (
    <Menu
      selectedKeys={[`${year}`]}
      onClick={item =>
        props.router.push({
          pathname: "/ptab/annual-report",
          query: {
            year: item.key
          }
        })
      }
      mode="horizontal"
    >
      {_range(2012, latestYear + 2).map(y => (
        <Menu.Item key={y}>{y}</Menu.Item>
      ))}
    </Menu>
  );
  return (
    <div style={styles.body}>
      <Helmet {...helmet} />
      <h2>{"PTAB Annual Report"}</h2>
      {yearSelector}
      {year && (
        <Card style={styles.gutter} key={year}>
          <div style={styles.gutter}>
            <PetitionsFiledSection year={year} />
          </div>
          <div style={styles.gutter}>
            <InstitutionRateContainer year={year} />
          </div>
          <Divider />
          <div style={styles.gutter}>
            <PetitionsBySectorSection year={year} />
          </div>
          <Divider />
          <div style={styles.gutter}>
            <HighTechPatentOwnersSection year={year} />
          </div>
          <Divider />
          <div style={styles.gutter}>
            <MostActivePetitioners year={year} />
          </div>
          <Divider />
          <div style={styles.gutter}>
            <MostActivePatentOwners year={year} />
          </div>
        </Card>
      )}
    </div>
  );
};

export default AnnualReport;
